import React from "react";
import {
    Edit,
    SimpleForm,
    TextInput,
    Loading,
    Toolbar,
    SaveButton,
    DeleteButton,
    useInput,
} from "react-admin";
import Grid from '@material-ui/core/Grid';
import WithProps from "../Custom/WithProps";
import { makeStyles } from '@material-ui/core/styles';
import Select from "react-select";
import { validateRequired } from "../../utils/Validations";
import './index.css';
import CustomEditor from "../CustomEditor";
import CustomAdminSelect from "../BestSellers/CustomAdminSelect";
import { DisclaimersSection } from "./DisclaimersSection";

const useStyles = makeStyles({
    capitalize: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
    },
    container: {
        width: '100%',
    },
    password: {
        margin: '10px 0',
        minHeight: '50px',
    },
    marginBounds: {
        marginTop: "20px"
    },
    formIterator: {
        "& ul": {
            width: "80%",
            display: "flex",
            justifyContent: "space-between",
        },
    }
});

const StoreEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton disabled={props.pristine} />
        {props.delete && <DeleteButton undoable={false} />}
    </Toolbar>
);

export const PropertySelect = props => {
    const { input } = useInput({ source: 'properties' })
    const options = [
        { value: 'lifetime_guarantee', label: 'Lifetime Guarantee' },
        { value: 'handcrafted_here', label: 'Handcrafted Here' },
        { value: 'genuine_materials', label: 'Genuine Materials' },
        { value: 'lifetime_resizing', label: 'Lifetime Resizing' },
        { value: 'ethically_sourced', label: 'Ethically Sourced' },
    ];

    const handleChange = callback => selectedopt => {
        callback(selectedopt?.map(option => option.value));
    }

    return (
        <Select
            {...input}
            isMulti={true}
            options={options}
            onChange={handleChange(input.onChange)}
            value={options.filter(option => input.value.includes(option.value))}
            styles={{ menu: provided => ({ ...provided, zIndex: 9999 })}}
        />
    )
}

export const MaterialDataEdit = props => {
    const classes = useStyles();
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    return (
        <Edit {...props} className='overflow-visible'>
            <WithProps>
                {({ record, ...props }) =>
                (<SimpleForm record={record} {...props} undoable={false} toolbar={<StoreEditToolbar delete={permissionsList.includes("delete_material_data")} />}>
                    <Grid container className={classes.container} justify="space-between">
                        <Grid item xs={5}>
                            <TextInput disabled source="material" label="Material" fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput disabled source="sku_code" label="Sku Code" validate={validateRequired} fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="image_url" label="Image url" validate={[validateRequired]} fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="emblem_image_url" label="Emblem Image url" validate={[validateRequired]} fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="video_url" label="Video Url" fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <CustomAdminSelect
                                label="Related Material"
                                source="related_material_sku"
                                resource="related-material-list"
                                optionValue="sku_code"
                                optionLabel="name"
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <p className="label">Properties</p>
                            <PropertySelect />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput placeholder="https:/example.com/shop/content/titanium" source="link" label="Link" fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput placeholder="/pages/titanium" source="emblem_link" label="Emblem Link" fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="scratch_resistant" type="number" label="Scratch Resistant" validate={validateRequired} fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="weight" label="Weight" type="number" validate={validateRequired} fullWidth />
                        </Grid>
                        <Grid container>
                            <Grid item style={{ width: '420px' }}>
                                <CustomEditor source="short_description" label="Description" />
                            </Grid>
                        </Grid>
                    </Grid>
                    <DisclaimersSection record={record} />
                </SimpleForm>)
                }
            </WithProps>
        </Edit>
    )
};